<template>
  <div class="">
    <h2>Домашнее задание</h2>
    <back></back>
    <div class="game">
      <div v-if="matriusTask && matriusTask.trainers.length">
        <MatriusTrainer 
          :student_task_id="matriusTask.student_task_id" 
          :items="matriusTask.trainers" 
        />
      </div>
      
      <div class="homework uk-margin-top" v-for="item in items" :key="item.id">
        <div v-if="item.params" :class="{read: !checkTask(item.id, item.params.current_lesson)}">
          <div class="homework__class">Задание для класса '{{ item.title }}':</div>
          <div class="homework__lesson" 
               v-html="item.params.current_lesson"
               v-if="checkTask(item.id, item.params.current_lesson)"></div>
          <p class="read-checkbox">
            <input @change="readTask(item.id, item.params.current_lesson)" 
                   type="checkbox" 
                   id="read-checkbox"
                   :checked="!checkTask(item.id, item.params.current_lesson)">
            <label for="read-checkbox">
              {{ checkTask(item.id, item.params.current_lesson) ? 'Я прочитал' : 'Прочитано'}}
            </label>
          </p>
        </div>
      </div>
      <HomeworkItems />
    </div>

    <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
      <template v-slot:content>
        <component 
          :is="popupContent" 
          :data="popupData" 
          :student_id="user.id"
          @close-popup="popupIsOpened = false"
          @complete-task="taskStatus = $event"          
        ></component>
      </template>
    </Popup>
  </div>
</template>

<script>
import HomeworkItems from './HomeworkItems';
import { matrius_task } from '../contests/matrius/matrius_task_mix'
import { mapGetters } from 'vuex'
export default {
  name: "homework",
  inject: ['http'],
  mixins: [ matrius_task ],
  data() {
    return {
      showTask: true,
      tasks: []
    }
  },
  components: {
    HomeworkItems
  },
  computed: {
    ...mapGetters({
			items: 'student/classes'
		}),
    checkTask() {
      return (id, task) => {
        if (this.tasks.length) {
          if (this.tasks.find(item => item.id === id && item.task === task)) {
            return false
          }
        }        
        return true
      }
    }
  },
  methods: {
    readTask(id, task) {
      if (this.tasks) {
        let sameTask = this.tasks.find(t => t.id === id && t.task === task)

        if (sameTask) {
          this.tasks = this.tasks.filter(t => t.task !== task && t.id !== id)          
        } else {
          let sameClassTask = this.tasks.find(t => t.id === id)
          if (sameClassTask) {
            this.tasks = this.tasks.filter(t => t.id !== sameClassTask.id)
          }
          this.tasks.push({
            id: id,
            task: task
          })
        }
      } else {
        this.tasks.push({
          id: id,
          task: task
        })
      }
    }
  },
  watch: {
    tasks() {
      localStorage.setItem('tasks', JSON.stringify(this.tasks))
    }
  },
  created() {
    this.getMatriusTask()
  },
  mounted() {
    if (localStorage.tasks) {
      let tasks = JSON.parse(localStorage.tasks)
      this.tasks = tasks ? tasks : []
    }        
  }
}
</script>

<style lang="scss" scoped>
.homework {
  position: relative;
}
.read-checkbox {
  margin: 0;
  top: 0;
  position: absolute;
  right: 10px;

  & input {
    width: 15px;
  }

  & label {
    cursor: pointer;
  }
}
.read {
  opacity: 0.5;
}

</style>